import { render, staticRenderFns } from "./IconSnowflakeThermometer.vue?vue&type=template&id=7c8cab23&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports